module.exports = __webpack_public_path__ + "5d910491131eb04f2ec0aa1028273454.MP3";